import makeStyles from 'e100-react-components/lib/styles/makeStyles';

import { Props as TitledSectionProps } from './index';

interface Props extends Required<Pick<TitledSectionProps, 'paddingTop' | 'paddingBottom' | 'fullHeight' | 'paddingLeft'>> {}

const useStyles = makeStyles(({ spacing }) => ({
  content: {
    padding: spacing(2),
    paddingBottom: ({ paddingBottom }: Props) => spacing(paddingBottom),
    paddingTop: ({ paddingTop }: Props) => spacing(paddingTop),
    paddingLeft: ({ paddingLeft }: Props) => spacing(paddingLeft),
    height: ({ fullHeight }: Props) => (fullHeight ? 'calc(100% - 1px)' : 'auto'),
    overflow: ({ fullHeight }: Props) => (fullHeight ? 'auto' : 'visible'),
  },
  subtitle: {
    marginBottom: spacing(1.5),
  },
  divider: {
    margin: 0,
  },
}));

export default useStyles;
